<template>
  <div class="sign-list">
    <el-row type="flex" :gutter="10" class="row">
      <el-col :span="9">
        <el-button @click="showAddFile()" size="small" type="primary" plain
          >文件保全</el-button
        >
      </el-col>
      <el-col :span="6">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-select v-model="selectedParm" placeholder="请选择" size="small">
              <el-option label="文件名称" value="contractName" />
              <el-option label="文件编号" value="applyNo" />
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="selectedParmInfo"
              size="small"
              placeholder="查询内容"
            />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-row>
          <el-date-picker
            v-model="datePikerArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: unset"
          />
        </el-row>
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="findScreenSign" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="table-wrap">
      <el-table
        class="data-list"
        :data="tableList"
        tooltip-effect="dark"
        ref="dataList"
        v-loading="loading"
        :header-cell-style="{
          background: '#f9f9f9',
          color: '#333333',
          fontWeight: '500',
        }"
      >
        <el-table-column
          label="文件编号"
          prop="applyNo"
          show-overflow-tooltip
        ></el-table-column>
        <!--<el-table-column label="文件名称" prop="contractName" show-overflow-tooltip >-->
        <!--</el-table-column>-->
        <el-table-column label="文件名称">
          <template slot-scope="scope">
            <apply-name
              applyType="applyList"
              :signInfo="{
                status: scope.row.signStatus,
                signNo: scope.row.signNo,
                applyNo: scope.row.applyNo,
                name: scope.row.contractName,
                row: scope.row,
                selfSign: scope.row.selfSign,
              }"
              :newFont="true"
            >
            </apply-name>
          </template>
        </el-table-column>

        <el-table-column label="备案号" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.vpresId"
              >{{ scope.row.vpresId }}
              <!--<img src="../../static/images/record.png" alt="">-->
            </span>
          </template>
        </el-table-column>

        <el-table-column
          label="保全备注"
          prop="remark"
          show-overflow-tooltip
          width="150"
        />
        <el-table-column label="保全时间">
          <template slot-scope="scope">{{
            scope.row.createTime | formatDateHM
          }}</template>
        </el-table-column>
        <!--<el-table-column label="操作" width="180">-->
        <!--<template slot-scope="scope">-->
        <!--<nuxt-link :to="{path: '/applySign/toDetailAnony', query: {applyNo: scope.row.applyNo}}" target="_blank" class="color-success span">查看</nuxt-link>-->
        <!--<template>-->
        <!--<span @click="gotoTestify(scope.row)" class="color-success span" style="margin-left: 10px">法律服务</span>-->
        <!--</template>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column label="操作" width="180">
          <template slot-scope="scope" v-if="scope.row.applySignStatus !== -1">
<!--            <div class="operate-box">-->
<!--              <nuxt-link-->
<!--                :to="{-->
<!--                  path: toNewDetail(scope.row.multiFile),-->
<!--                  query: { applyNo: scope.row.applyNo },-->
<!--                }"-->
<!--                target="_blank"-->
<!--                class="color-success span"-->
<!--                >查看</nuxt-link-->
<!--              >-->
<!--            </div>-->
            <span
              v-if="scope.row.vpresId"
              @click="openCSDialog(scope.row)"
              class="com-normal-btn"
              >出证</span
            >

            <certiServicepopover
              listTyp="seniorList"
              :param="{
                signNo: scope.row.signNo || '',
                applyNo: scope.row.applyNo || '',
              }"
            >
              <span class="color-success">证书</span>
            </certiServicepopover>
          </template>
        </el-table-column>
        <no-data text="暂无数据" slot="empty" />
      </el-table>
    </div>
    <!--分页栏-->
    <el-row class="pageation row">
      <el-col :span="24" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="screenParme.itemPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="screenParme.pageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next, total"
          :total="screenParme.pageTotal"
        />
        <el-go
          :page-size="screenParme.pageSize"
          :total="screenParme.pageTotal"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <el-dialog
      title="文件保全"
      :visible.sync="insureDialogVisible"
      @close="getSignLists"
      width="60%"
      class="insurance-info"
    >
      <div class="info-box">
        <div style="overflow-y: auto; height: 400px">
          <el-row type="flex" class="row">
            <el-col
              :span="1"
              style="margin-top: 67px; position: absolute; left: 0"
            >
              <template v-for="(item, i) in fileInfoList">
                <img
                  :key="i"
                  v-show="item.loading"
                  style="width: 16px; margin-bottom: 15px"
                  src="/images/u2.gif"
                />
              </template>
            </el-col>
            <el-col :span="6">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".pdf,.doc,.docx,.jpg,.png,.bmp"
                action=""
                :on-change="handleFileChange"
                :on-remove="handleFileRemove"
                :file-list="fileList"
                :multiple="true"
                :auto-upload="false"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选取文件</el-button
                >
                <div class="upload-my-tip">
                  已选中{{ fileList.length }}份文件<a @click="clearAllFiles()"
                    >清空文件</a
                  >
                </div>
                <div slot="tip" class="el-upload__tip">
                  只能上传.pdf、.doc、.docx、.jpg、.png、.bmp格式文件，且不超过30MB
                </div>
              </el-upload>
            </el-col>
            <el-col :span="17">
              <ul class="file-info-ls">
                <li v-for="item in fileInfoList" :key="item.uid">
                  <el-row type="flex" class="row">
                    <el-col :span="12" class="padding-r-10">
                      <el-input
                        v-model="item.fileName"
                        size="mini"
                        :readonly="item.loading"
                        placeholder="请输入文件名称"
                      />
                    </el-col>
                    <el-col :span="12" class="padding-l-10">
                      <el-input
                        v-model="item.remark"
                        size="mini"
                        :maxlength="100"
                        :readonly="item.loading"
                        placeholder="保全备注"
                      />
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
        <div>
          <p>
            已成功保全
            <span style="color: red">{{ uploadedLength }}</span> 份文件
          </p>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" type="info" @click="getSignLists()"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="uploadFileList()"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="authDialog" title="实名认证" width="475px">
      <p class="authDialog">
        <img
          src="../../static/images/warning.png"
        />您还未完成实名认证，认证后才能执行该操作。
      </p>
      <template slot="footer">
        <el-button
          style="border: none; background: #ec1c1c; color: #ffffff"
          size="small"
          @click="gotoAuth"
          >去认证</el-button
        >
      </template>
    </el-dialog>

    <certiServiceDialog
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      listType="userList"
      :param="cSDialogData"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog>
  </div>
</template>

<script>
import {
  postApplyPage,
  presAndSign,
  ApiMethods,
  configUrl
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../../components/go/Go";
import ApplyName from "@/components/apply-list/contractName";
import Vue from "vue";
import ApplyHandles from "@/components/apply-list/handles";
import CertiServicepopover from "@/components/apply-list/certiServicepopover";
import CertiServiceDialog from "@/components/apply-list/certiServiceDialog";
import CorpApplyName from "@/components/apply-list/corpContractName";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import GlobalConfig from "../../assets/js/config/global";

function getStore () {
  return Vue.prototype.$storeInstance;
}

export default {
  components: {
    ElGo,
    ApplyName,
    ApplyHandles,
    CertiServicepopover,
    CertiServiceDialog,
    CorpApplyName
  },
  data () {
    return {
      // 签署列表
      tableList: null,
      uploadedLength: 0,
      // 筛选
      screenParme: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        createType: 2,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        vpresId: null
      },
      selectedParm: "contractName",
      selectedParmInfo: "",
      datePikerArr: null,
      badge: 0,
      loading: null,
      insureDialogVisible: false,
      fileList: [],
      fileInfoList: [],
      authDialog: false,
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {} //证书弹出框数据
    };
  },
  beforeMount () { },
  mounted () {
    this.getSignLists();
  },
  computed: {
    toNewDetail () {
      return function (val) {
        return val === 1
          ? "/applySign/toDetailMultiAnony"
          : "/applySign/toDetailAnony";
      };
    }
  },
  watch: {
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.screenParme.beginDate = val[0];
          this.screenParme.endDate = val[1];
        } else {
          this.screenParme.beginDate = this.screenParme.endDate = null;
        }
      },
      deep: true
    },
    selectedParm: function (newVal, oldVal) {
      this.screenParme[newVal] = this.screenParme[oldVal];
      this.screenParme[oldVal] = null;
    },
    selectedParmInfo: function (val) {
      this.screenParme[this.selectedParm] = val;
    }
  },
  methods: {
    //证书
    async openCSDialog (rowData) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: rowData["signInfoNo"] || "",
        applyNo: rowData.applyNo || ""
      };
      let viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        // this.setCSDialogData(certiRes.data[0]);

        if (!certiRes.data || certiRes.data.lengt == 0)
          return this.$message.error("初始化数据失败");
        if (certiRes.data.length === 1) {
          let _data = { ...certiRes.data[0] };
          return this.gotoRedirectTesity(_data);
        }
      } else {
        _this.$message.error(certiRes.description);
      }
    },
    async gotoRedirectTesity (data) {
      //非大陆的账户不能去出证
      if ([2, 3, 4].includes(data.identityType)) {
        return this.$message.error(
          "该主体个人实名认证为港澳台/护照证件，无法申请出证。"
        );
      }
      // newUrl 0 旧业面 1 新页面
      let _this = this,
        ow = null;
      if (!isInDingTalk) ow = window.open("about:blank");
      if (
        this.$store.getters.currentAuthUser &&
        this.$store.getters.currentAuthUser.corpUserId
      ) {
        data.corpUserId = this.$store.getters.currentAuthUser.corpUserId;
      }
      let redirectTesityRes = '';
      //申请仲裁
      redirectTesityRes = await ApiMethods.CertiController.redirectTesity(
        data
      );
      if (redirectTesityRes.success) {
        if (!isInDingTalk) {
          ow.location.href = redirectTesityRes.data;
        } else {
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = redirectTesityRes.data;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        }
      } else {
        _this.$message.error(redirectTesityRes.description || this.$tip);
        ow.close();
      }
    },
    setCSDialogData (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
    },
    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },

    gotoAuth () {
      if (+getStore().getters.authUser.userType === 0) {
        getStore().$router.push("/auth/personalIdentityAuth");
      } else {
        getStore().$router.push("/auth/authGuide");
      }
    },
    uploadFileList () {
      if (this.fileList.length === 0) return this.$message.error("请选取文件");
      const fl = Object.assign([], this.fileList);
      fl.forEach((item, index) => {
        const fd = new FormData();
        const f_info = this.fileInfoList.filter(i => i.uid === item.uid)[0];
        fd.append("file", item.raw);
        fd.append("fileName", f_info.fileName || item.name.split(".")[0]);
        fd.append("remark", f_info.remark);
        this.$set(this.fileInfoList[index], "loading", true);
        presAndSign(fd).then(res => {
          if (!res.success) return this.$message.error(res.description || '操作失败');
          this.$message.success('操作成功')
          this.fileInfoList = this.fileInfoList.filter(i => i.uid !== item.uid);
          this.fileList = this.fileList.filter(i => i.uid !== item.uid);
          this.uploadedLength++;
        });
      });
    },
    handleFileChange (file) {
      this.fileInfoList.push({
        fileName: file.name.split(".")[0],
        remark: "",
        uid: file.uid
      });
      this.fileList.push(file);
      this.validFile(file);
    },
    validFile (file) {
      const f_t = `pdf,doc,docx,jpg,png,bmp`;
      const f_n = file.name.split(".");
      const tp = f_n[f_n.length - 1];
      if (file.size > 30 * 1024 * 1024) {
        this.handleFileRemove(file);
        return this.$message.error("文件大小不能超过30M");
      }
      if (f_t.indexOf(tp) === -1) {
        this.handleFileRemove(file);
        return this.$message.error(
          "只能上传.pdf、.doc、.docx、.jpg、.png、.bmp格式文件"
        );
      }
    },
    handleFileRemove (file) {
      this.fileInfoList = this.fileInfoList.filter(i => i.uid !== file.uid);
      this.fileList = this.fileList.filter(i => i.uid !== file.uid);
    },
    clearAllFiles () {
      this.fileInfoList = [];
      this.fileList = [];
    },
    resetScreenParams () {
      this.selectedParm = "contractName";
      this.selectedParmInfo = "";
      this.screenParme = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        createType: 2
      };
      this.datePikerArr = null;
    },
    // 重置
    rest () {
      this.resetScreenParams();
      this.findScreenSign();
    },
    // 查找筛选
    findScreenSign: function (screen) {
      if (screen) {
        this.screenParme.itemPage = screen.itemPage;
        this.screenParme.pageSize = screen.pageSize;
      } else {
        this.screenParme.itemPage = 1;
        this.screenParme.pageSize = 10;
      }
      this.getSignLists();
    },
    showAddFile () {
      if (this.$store.getters.authUser.identityAuth > -1) {
        this.clearAllFiles();
        this.uploadedLength = 0;
        this.insureDialogVisible = true;
      } else {
        // this.authDialog = true;
        this.$confirm(
          "您的账号还未完成实名认证，无法使用完整功能！",
          "提示",
          {
            confirmButtonText: "去认证",
            cancelButtonText: "以后再说",
            type: "warning"
          }
        )
          .then(() => {
            this.gotoAuth();
          })
          .catch(() => {
          });
      }
    },
    // 获取签署列表
    getSignLists: function () {
      this.loading = true;
      this.insureDialogVisible = false;
      postApplyPage(this.screenParme)
        .then(data => {
          this.screenParme.pageSize = data.pageSize;
          this.screenParme.itemPage = data.pageNum;
          this.screenParme.pageTotal = data.total;
          this.badge = data.total;
          this.tableList = data.data;
          this.$emit("update:badge", data.total);
        })
        .catch(e => { })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页
    handleSizeChange (val) {
      this.screenParme.itemPage = 1;
      this.screenParme.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.screenParme.itemPage = val;
      this.getSignLists();
    },
    toHistory () {
      let url = configUrl().entEbq + "/enterprise/contractPage";
      if (this.$store.getters.currentAuthUser.userType === 0) {
        url = configUrl().aresUrl + "/contract";
      }
      isInDingTalk ? location.href = url : window.open(url, "_blank");
    },
    /**
     * @param value value
     * @param space space
     */
    transferFormat (value, space) {
      if (typeof space !== "number") {
        return value;
      }
      if (value.length < space) return value;
      let v = "";
      for (let index = 0; index < value.length; index++) {
        if (index > 0 && index % space === 0) {
          v += "<br/>";
        }
        v += value[index];
      }
      return v;
    },
    // 证书
    gotoTestify: function (item) {
      let _this = this;
      let param = {
        signNo: item.signInfoNo || "",
        applyNo: item.applyNo || ""
      };
      ApiMethods.UserApplySignController.viewUrl(param).then(viewResult => {
        if (!viewResult.success) {
          return _this.$message.error(
            viewResult.description || "初始化数据失败1"
          );
        }
        ApiMethods.ApplySignController.certi(viewResult.data).then(
          redirectResult => {
            if (redirectResult.success) {
              let { href } = this.$router.resolve({
                path: "/certi/certiPage",
                query: redirectResult.data
              });
              letnewWWindow;
              if (!isInDingTalk) newWindow = window.open();
              isInDingTalk ? location.href = href : newWindow.location.href = href;
            } else {
              _this.$message.error(redirectResult.description);
            }
          }
        );
      });
    }
  },
  name: "preservation"
};
</script>
<style>
.el-upload-list {
  margin-top: 30px;
}
</style>

<style lang="less" scoped>
/*/deep/.el-table__row .contract-name > span[data-v-17dc534e]{*/
/*font-weight: normal !important;*/
/*&:hover{*/
/*border-bottom: none !important;*/
/*color: #000;*/
/*cursor:auto !important;*/
/*}*/
/*}*/

/deep/.el-table__row .cell {
  display: flex;
}
.upload-my-tip {
  position: absolute;
  top: 23px;
  left: 110px;

  a {
    color: #ec1c1c;
    margin-left: 5px;
    text-decoration: underline;
    cursor: pointer;
  }
}

.padding-r-10 {
  padding-right: 10px;
}

.padding-l-10 {
  padding-left: 10px;
}

.file-info-ls {
  margin-top: 60px;

  .el-row--flex {
    padding: 0 !important;
    height: auto !important;
    min-height: 31px !important;
  }
}

.custom-checkbox {
  /deep/ .el-checkbox__label {
    color: #606266;
  }
}

.el-upload__tip {
  position: absolute;
}

.operation span {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.insurance-info .info-box {
  padding: 0 20px 20px 20px;

  p {
    margin-bottom: 10px;
  }

  .title {
    vertical-align: top;
    display: inline-block;
    text-align: right;
    width: 100px;
    margin-right: 10px;
  }

  .box {
    display: inline-block;
  }
}

.insurance-dialog .insurance-form {
  width: 80%;
  margin: 0 auto 40px auto;

  h1 {
    text-align: center;
    font-family: "微软雅黑";
    font-size: 19px;
    font-weight: 400;
    color: #333333;
  }

  .span-important {
    padding: 0 5px;
    color: white;
    background: #ec1c1c;
    border-radius: 4px;
  }

  .span-important-color {
    color: #ec1c1c;
  }

  .pay-money {
    color: #ec1c1c;

    span {
      font-size: 22px;
    }
  }

  .btn {
    width: 220px;
  }
}

.file-name {
  display: inline-block;
  cursor: pointer;

  i {
    display: inline-block;
    width: 22px;
    height: 18px;
    position: absolute;
    top: 15px;
    left: -13px;
  }
}

.action {
  span {
    // cursor: pointer;
  }
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.sign-list {
  max-width: 1200px;
  margin: 0 auto;

  .color-success {
    cursor: pointer;
    color: #290202;
    font-weight: bold;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    font-size: 14px;
    margin-right: 8px;
    &:hover {
      color: red;
    }
  }

  .right-wrap {
    margin-left: 215px;
    background-color: #ffffff;

    .table-wrap {
      padding: 0 16px;
    }
  }

  .pageation {
    height: 62px;
    padding: 15px;
    border-top: 0;
  }

  .dialog-footer {
    padding-bottom: 20px;

    .btn {
      width: 30%;
    }
  }

  nav.nav-bar {
    width: 100%;
    border: 1px dashed #d7d7d7;
    overflow: hidden;

    li.nav-item {
      margin-right: 14px;
      padding: 10px 15px;
      color: #666;
      border: none;
      background: #fff;
      cursor: pointer;
    }

    .nav-item.active {
      color: #ec1c1c;
    }

    ul.nav {
      width: 100%;
    }
  }
}
.authDialog {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 40px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 2, 2, 0.65);

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
/deep/ .el-button--small:hover {
  opacity: 0.7 !important;
}
</style>



// WEBPACK FOOTER //
// pages/signInfo/preservation.vue